import { CheckBoxChecked } from './cmnTemplateForApretude.constant';

export const DEFAULT_FORMFIELD_ONLY_FOR_VYEPTI = {
  prescriberFax: '(855) 710-6616',
};

export const DEFAULT_FORMFIELD_VYEPTI = {
  quantity: 1,
  refills: 1,
  infuse: 100,

  'checkbox-vyepti-single-use': CheckBoxChecked.yes,
  'checkbox-new-patient': CheckBoxChecked.no,

  'checkbox-infusion-instructions': true,
  'checkbox-supplies': true,
  'checkbox-anaphylaxis-protocol': true,
  'checkbox-iv-flush': true,
  'checkbox-premedication': true,

  migrainStartDate: '',
  headacheDaysPerMonth: 'Unknown',
  lastTreatmentDate: '',
  previousMigraineMedication: '',
};

export {
  CheckBoxChecked,
};

export const PID_ProvidersAndCreatePDF = 'PID_ProvidersAndCreatePDF';
export const QID_NewToVyeptiCheckbox = 'QID_NewToVyeptiCheckbox';
export const QID_MigrainStartDateInput = 'QID_MigrainStartDateInput';
export const QID_HeadacheDaysPerMonthInput = 'QID_HeadacheDaysPerMonthInput';
export const QID_LastTreatmentDateInput = 'QID_LastTreatmentDateInput';
export const QID_DrugAllergiesInput = 'QID_DrugAllergiesInput';
export const QID_PreviousMigraineMedicationInput = 'QID_PreviousMigraineMedicationInput';
